import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Observable, Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { OrganizationService } from 'app/views/appviews/organization/organization.service';
import { IDtoRiskPremium } from 'app/shared/models/organization/dto-risk-premium.model';
import { IDtoCompany } from 'app/shared/models/organization/dto-company.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { ISelect } from 'app/shared/models/select.model';
import { RecruitmentService } from 'app/views/appviews/recruitment/recruitment.service';
import { map } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-modal-company',
    styleUrls: ['./modal-company.style.scss'],
    templateUrl: './modal-company.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalCompanyComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formCompany: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Retorno a pantalla padre */
    public onClose: Subject<any>;
    /**Variables */
    private companyId?: number;
    private company: IDtoCompany;
    private action: string;
    /**Listas */
    private riskPremiums = new Array() as IDtoRiskPremium[];
    private catalogStates: Observable<ISelect[]>;
    private catalogTowns: ISelect[];
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tableModules: DatatableComponent;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private organizationService: OrganizationService
        , private configGeneral: AppConfig
        , private identityService: IdentityService
        , private spinner: NgxSpinnerService
        , private recruitmentService: RecruitmentService) {
        this.initializeFormRiskPremium();
        this.catalogStates = this.recruitmentService.getCatalogStates();
    }
    ngOnInit(): void {
        this.onClose = new Subject();
        if (this.action === 'edit') {
            let s = {} as ISelect;
            s.id = this.company.stateId;
            this.company.stateId = this.company.stateId.toString();
            this.company.townId = this.company.townId.toString();
            this.getCatalogTowns(s);
            this.formCompany.patchValue(this.company);
        }
    }
    private initializeFormRiskPremium() {
        this.formCompany = this.formBuilder.group({
            codeNom: [null, []],
            rfc: [null, [Validators.required, Validators.maxLength(13)]],
            address: [null, [Validators.required, Validators.maxLength(255)]],
            name: [null, [Validators.required, Validators.maxLength(150)]],
            shortName: [null, [Validators.required, Validators.maxLength(50)]],
            isActive: [null, [Validators.required]],
            isVisible: [null, [Validators.required]],
            description: [null, [Validators.maxLength(255)]],
            payrollTaxPercentage: [null, [Validators.required]],
            interiorNumber: [null, Validators.maxLength(10)],
            externalNumber: [null, [Validators.required, Validators.maxLength(10)]],
            postalCode: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
            suburb: [null, [Validators.required, Validators.maxLength(50)]],
            stateId: [null, Validators.required],
            townId: [null, Validators.required],
            activity: [null, [Validators.required, Validators.maxLength(100)]],
            bankAccount: [null, [Validators.required, Validators.maxLength(18)]]
        });
    }
    private getCatalogTowns(dto: ISelect): void {
        this.catalogTowns = null;
        this.formCompany.get('townId').setValue(null);
        if (dto === undefined) {
            return;
        }
        this.recruitmentService.getCatalogTownsByStateIdCodeNomStructure(dto.id).subscribe(t =>{
            this.catalogTowns = t;
        });
    }
    private submit(): void {

        if (this.formCompany.valid) {
            if (this.action === 'add') {
                this.save();
            } else {
                this.update();
            }
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.configGeneral.touchedControls(this.formCompany);
        }
    }
    private save(): void {
        this.spinner.show();
        const dto = this.formCompany.value as IDtoCompany;
        dto.codeNomState = dto.stateId.toString();
        dto.codeNomTown = this.catalogTowns.filter(p => p.id == dto.townId)[0].additional;
        this.organizationService.addCompany(dto)
            .subscribe(
                (x) => {
                    this.spinner.hide();
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let c = x.data as IDtoCompany;
                        this.addModuleLog(c.id, 'new');
                        this.onClose.next(c);
                        this.bsModalRef.hide();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private update(): void {
        this.spinner.show();
        const dto = this.formCompany.value as IDtoCompany;
        dto.codeNomState = dto.stateId.toString();
        dto.codeNomTown = this.catalogTowns.filter(p => p.id == dto.townId)[0].additional;
        dto.id = this.company.id;
        this.organizationService.updateCompany(dto)
            .subscribe(
                (x) => {
                    this.spinner.hide();
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.addModuleLog(dto.id, 'update');
                        this.onClose.next(dto);
                        this.bsModalRef.hide();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Companies';
        dto.module = 'companies';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
